// Who may decide an approval from the invoice screen, mirroring the API's
// can_act_on_invoice / can_act_on_line_item (XPEN-3804): a privileged role acts for
// anyone; otherwise only the person the request waits for. A role that merely has
// the approve action (a universal proxy, for instance) does not decide others' requests.
export const PRIVILEGED_APPROVAL_ROLES = ['SuperAdmin', 'Admin', 'Manager'];

// json.approver denorms to member #0 on an any-of head; every visibility gate
// keyed on the head (buttons, per-line rows, approver display) must consult
// approvers_list[0] directly so members #1..N are not locked out.
export const isAnyOfHead = (head) => Array.isArray(head) && head.length > 0;

export const isCurrentUserAtInvoiceHead = (invoice, username) => {
  const head = invoice?.json?.approvers_list?.[0];
  if (isAnyOfHead(head)) return head.some((m) => m?.username === username);
  return invoice?.json?.approver?.username === username;
};

// origin_role first, as the API does: it survives connect-as-role.
const isPrivileged = (data) => PRIVILEGED_APPROVAL_ROLES.includes(data?.origin_role || data?.role);

export const canDecideInvoice = (invoice, data) =>
  invoice?.status === 'Need_Approval' && (isPrivileged(data) || isCurrentUserAtInvoiceHead(invoice, data?.username));

export const canDecideLine = (item, data) => {
  if (item?.Status !== 'Need_Approval') return false;
  if (isPrivileged(data)) return true;
  const members = Array.isArray(item.approver_group) && item.approver_group.length ? item.approver_group : [item.approver];
  return members.some((member) => member?.username && member.username === data?.username);
};
